<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12"><div>
        <el-row :gutter="20" class="data-cards">
          <el-col :span="8">
            <el-card shadow="always" class="data-card">
              <div slot="header" class="clearfix" style="color: #74c74a">
                <i class="el-icon-top"></i>今日新增
              </div>
              <div style="text-align: center" v-loading="loading[0]">{{ statistics.today }}</div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="always" class="data-card">
              <div slot="header" class="clearfix" style="text-align: center;color: #E6A23C">
                <i class="el-icon-bottom"></i>待处理数据
              </div>
              <div style="text-align: center;" v-loading="loading[1]">{{ statistics.pending }}</div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card shadow="always" class="data-card">
              <div slot="header" class="clearfix" style="text-align: center;color: #409eff">
                <i class="el-icon-bottom"></i>已处理数据
              </div>
              <div style="text-align: center;" v-loading="loading[2]">{{ statistics.processed }}</div>
            </el-card>
          </el-col>
        </el-row>
        <v-chart class="chart" :option="option1" ref="chart1" v-loading="loading[3]"/>
      </div></el-col>
      <el-col :span="12"><el-row :gutter="20" class="charts-row">
        <!-- 公司词云分析 -->
        <el-col :span="24">
          <el-card shadow="always" class="chart-card">
            <div slot="header">
              公司词云分析
              <el-radio-group v-model="wordCloudType" size="small" style="float: right" >
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button label="正面新闻">正面</el-radio-button>
                <el-radio-button label="负面新闻">负面</el-radio-button>
              </el-radio-group>
            </div>
            <v-chart :option="option3" style="height: 350px" ref="chart3" v-loading="loading[4]"></v-chart>
          </el-card>
        </el-col>
      </el-row></el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="12"><el-row :gutter="20" class="charts-row">
        <!-- 热点话题分析 -->
        <el-col :span="24">
          <el-card shadow="always" class="chart-card">
            <div slot="header">
              热点公司分析
              <el-radio-group v-model="wordCloudType2" size="small" style="float: right">
                <el-radio-button label="">全部</el-radio-button>
                <el-radio-button label="正面新闻">正面</el-radio-button>
                <el-radio-button label="负面新闻">负面</el-radio-button>
              </el-radio-group>
            </div>
            <el-table v-loading="loading[5]"
                :data="hotCompany"
                style="width: 100%">
              <el-table-column
                  prop="company"
                  label="公司名"
                  width="180">
                <template v-slot="scope">
                  <el-button type="text" @click="handleChickCompany(scope.row.company)">{{scope.row.company}}</el-button>
                </template>
              </el-table-column>
              <el-table-column
                  prop="count"
                  label="相关新闻">
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row></el-col>
      <el-col :span="12"><el-row :gutter="20" class="charts-row">
        <!-- 情感分布分析 -->
        <el-col :span="24">
          <el-card shadow="always" class="chart-card">
            <div slot="header">
              情感分布分析
            </div>
            <v-chart class="chart" :option="option2" ref="chart2" v-loading="loading[6]"></v-chart>
          </el-card>
        </el-col>
      </el-row></el-col>
    </el-row>
  </div>
</template>

<script>
import 'echarts-wordcloud'
import axios from 'axios'
import {mapState} from "vuex";
import VChart from "vue-echarts";


export default {
  name: 'DataCharts',
  computed: {
    ...mapState(['baseUrl'])
  },
  components: {VChart},
  data() {
    return {

      loading: [false,false,false,false,false,false,false],
      hotCompany:[{company:"",count:0}],
      wordCloudType:"",
      wordCloudType2:"",
      option1: {
        title: {
          text: '一周记录'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['负面新闻', '正面新闻', '其他新闻']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '负面新闻',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '正面新闻',
            type: 'line',
            stack: 'Total',
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '其他新闻',
            type: 'line',
            stack: 'Total',
            data: [150, 232, 201, 154, 190, 330, 410]
          },

        ]
      },
      option2: {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '新闻总量',
            type: 'pie',
            radius: '50%',
            data: [
              {
                value: 1048,
                name: '负面新闻',
                itemStyle: {
                  color: '#e05555' // 指定颜色
                }},
              {
                value: 735,
                name: '正面新闻',
                itemStyle: {
                  color: '#41b883' // 指定颜色
                }},
              {
                value: 580,
                name: '其他新闻',
                itemStyle: {
                  color: '#3c3c3c' // 指定颜色
                }},
            ],
            label: {      // 控制标签文字
              show: false
            },
            labelLine: {
              show: false         // 关闭连接线
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      option3:{
        series: [{
          type: 'wordCloud',

          /*要绘制的“云”的形状。可以是为回调函数，或一个关键字。
          可用的形状有(circle)圆形(默认)、(cardioid)心形，(diamond)菱形，(triangle-forward)三角形向前，(triangle)三角形，(pentagon)五边形和(star)星形。*/
          shape: 'circle',

          //保持maskImage的宽高比或1:1的形状，他的选项是支持从echarts-wordcloud@2.1.0
          keepAspect: false,

          //一个轮廓图像，其白色区域将被排除在绘制文本之外
          //意思就是可以通过图片，来自定义词云的形状
          // maskImage: maskImage,

          //设置显示区域的位置以及大小
          left: 'center',
          top: 'center',
          right: null,
          bottom: null,
          width: '70%',
          height: '80%',

          //数据中的值将映射到的文本大小范围。默认大小为最小12px，最大60px。
          sizeRange: [12, 60],

          //文本旋转范围和步进度。文本将通过rotationStep:45在[- 90,90]范围内随机旋转
          rotationRange: [-90, 90],
          rotationStep: 45,

          //以像素为单位的网格大小，用于标记画布的可用性
          //网格尺寸越大，单词之间的间距越大。
          gridSize: 8,

          //设置为true，允许文字部分在画布外绘制。
          //允许绘制大于画布大小的单词
          //从echarts-wordcloud@2.1.0开始支持此选项
          drawOutOfBound: false,

          //如果字体太大而无法显示文本，
          //是否收缩文本。如果将其设置为false，则文本将不渲染。如果设置为true，则文本将被缩小。
          //从echarts-wordcloud@2.1.0开始支持此选项
          shrinkToFit: false,

          // 执行布局动画。当有大量的单词时，关闭它会导致UI阻塞。
          layoutAnimation: true,

          //全局文本样式
          textStyle: {
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
            // Color可以是一个回调函数或一个颜色字符串
            color: function () {
              // Random color
              return 'rgb(' + [
                Math.round(Math.random() * 160),
                Math.round(Math.random() * 160),
                Math.round(Math.random() * 160)
              ].join(',') + ')';
            }
          },
          emphasis: {
            focus: 'self',

            textStyle: {
              textShadowBlur: 10,
              textShadowColor: '#333'
            }
          },

          //数据是一个数组。每个数组项必须具有名称和值属性。
          data: [
            {name: 'Farrah',value: 366},
            {name: "汽车",value: 900},
            {name: "视频",value: 606},
            // ...
          ]
        }]
      },
      statistics: {
        today: 0,
        pending: 0,
        processed: 0
      }
    }
  },
  methods:{
  handleChickCompany(company){
    this.$router.replace({name:'DataTable',params:{company}})
  },
  handleChart1(){
    let {today} = this.getRecentDates();
    let {dates,weekdays}= this.getWeekDates();
    this.$set(this.loading,0,true)
    this.$set(this.loading,1,true)
    this.$set(this.loading,2,true)
    this.option1.xAxis.data = weekdays;
    axios.get(`${this.baseUrl}/news/query/light`, { params: { startDate: today, endDate: today } }).then(responses=>{
      this.statistics.today = responses.data.total;
    }).finally(()=>{
      this.$set(this.loading,0,false)
    })
    axios.get(`${this.baseUrl}/news/query/light`, { params: { finish: 0 } }).then(responses=>{
      this.statistics.pending = responses.data.total;
    }).finally(()=>{
      this.$set(this.loading,1,false)
    })
    axios.get(`${this.baseUrl}/news/query/light`, { params: { finish: 1 } }).then(responses=>{
      this.statistics.processed = responses.data.total;
    }).finally(()=>{
      this.$set(this.loading,2,false)
    })



    // 创建所有请求的数组
    const requests = [
      // 添加循环中的请求
      ...dates.flatMap((date) => [
        axios.get(`${this.baseUrl}/news/query/light`, {
          params: { startDate: date, endDate: date, tag: "负面新闻" }
        }),
        axios.get(`${this.baseUrl}/news/query/light`, {
          params: { startDate: date, endDate: date, tag: "正面新闻" }
        }),
        axios.get(`${this.baseUrl}/news/query/light`, {
          params: { startDate: date, endDate: date, tag: "其他新闻" }
        })

      ])
    ];
    this.$set(this.loading,3,true)
    Promise.all(requests).then(responses => {
      console.log(responses)
      // 处理后每个日期的三个新闻类型数据
      const tagCount = 3; // 每个日期对应3个请求（负面、正面、其他）
      dates.forEach((date, index) => {
        const baseIndex = index * tagCount; // 前3个是统计，之后每3个一组
        this.option1.series[0].data[index] = responses[baseIndex].data.total;     // 负面
        this.option1.series[1].data[index] = responses[baseIndex + 1].data.total; // 正面
        this.option1.series[2].data[index] = responses[baseIndex + 2].data.total; // 其他
        // 输出日志（可选）
        console.log(`${date}=bad=>${responses[baseIndex].data.total}`);
        console.log(`${date}=god=>${responses[baseIndex + 1].data.total}`);
        console.log(`${date}=oth=>${responses[baseIndex + 2].data.total}`);
      });
      this.$refs.chart1 && this.$refs.chart1.clear();
      this.$refs.chart1 && this.$refs.chart1.setOption(this.option1);
    }).catch(error => {
      console.error('获取数据失败:', error)
      this.$message.error('获取数据失败，请稍后重试')
    }).finally(()=>{
      this.$set(this.loading,3,false)
    });
  },
  handleChart2(){
    this.$set(this.loading,4,true)
    axios.get(`${this.baseUrl}/news/company`, {
      params: {
        pageSize:20,
        tag:this.wordCloudType
      }
    }).then((res)=>{
      this.option3.series[0].data=[]
      for(let i=0;i< res.data.data.length;i++){
        if (res.data.data[i].company==="未知" || res.data.data[i].company==="待定"){
          continue
        }
        this.option3.series[0].data.unshift({
          name:res.data.data[i].company,
          value:res.data.data[i].count
        })
      }
      console.log(this.option3)
      this.$refs.chart3 && this.$refs.chart3.clear();
      this.$refs.chart3 && this.$refs.chart3.setOption(this.option3);

    }).catch(error => {
      console.error('获取数据失败:', error)
      this.$message.error('获取数据失败，请稍后重试')
    }).finally(()=>{
      this.$set(this.loading,4,false)
    })
  },
  handleChart3(){
    this.$set(this.loading,6,true)
    const requests = [
      axios.get(`${this.baseUrl}/news/query/light`, { params: { tag:"负面新闻" } }),
      axios.get(`${this.baseUrl}/news/query/light`, { params: { tag:"正面新闻" } }),
      axios.get(`${this.baseUrl}/news/query/light`, { params: { tag:"其他新闻" } }),
    ]
    Promise.all(requests).then(responses => {
      this.option2.series[0].data[0].value=responses[0].data.total;
      this.option2.series[0].data[1].value=responses[1].data.total;
      this.option2.series[0].data[2].value=responses[2].data.total;
      this.$refs.chart2 && this.$refs.chart2.clear();
      this.$refs.chart2 && this.$refs.chart2.setOption(this.option2);
    }).catch(error=>{
      console.error('获取数据失败:', error)
      this.$message.error('获取数据失败，请稍后重试')
    }).finally(()=>{
      this.$set(this.loading,6,false)
    })
  },
  handleHotCompany(){
    this.$set(this.loading,5,true)
    axios.get(`${this.baseUrl}/news/company`, {
      params: {
        pageSize:6,
        tag:this.wordCloudType2
      }
    }).then((res)=>{
      this.hotCompany=[]
      for(let i=0;i< res.data.data.length;i++){
        if (res.data.data[i].company==="未知" || res.data.data[i].company==="待定"){
          continue
        }
        this.hotCompany.push(res.data.data[i])
      }
      console.log(this.hotCompany)
    }).catch(error=>{
      console.error('获取数据失败:', error)
      this.$message.error('获取数据失败，请稍后重试')
    }).finally(()=>{
      this.$set(this.loading,5,false)
    })
  },
  getRecentDates() {
    const today = new Date();
    const yesterday = new Date(today);
    const dayBeforeYesterday = new Date(today);

    yesterday.setDate(today.getDate() - 1);
    dayBeforeYesterday.setDate(today.getDate() - 2);

    const formatDate = (date) => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    return {
      today: formatDate(today),
      yesterday: formatDate(yesterday),
      dayBeforeYesterday: formatDate(dayBeforeYesterday)
    };
  },
  formatDate(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  },

  getWeekday(date) {
    const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    return weekdays[date.getDay()];
  },
  getWeekDates() {
    const dates = [];
    const weekdays = [];

    for (let i = 0; i < 7; i++) {
      const date = new Date();
      date.setDate(date.getDate() - i);
      const formattedDate = this.formatDate(date);
      const weekday = this.getWeekday(date);
      dates.unshift(formattedDate); // 将日期添加到数组开头
      weekdays.unshift(weekday); // 将星期几添加到数组开头
    }

    return { dates, weekdays };
  },
  handleResize(){
    this.$refs.chart1 && this.$refs.chart1.resize()
    this.$refs.chart2 && this.$refs.chart2.resize()
    this.$refs.chart3 && this.$refs.chart3.resize()
  }
  },
  mounted() {

    this.handleChart2()
    this.handleChart3()
    this.handleHotCompany()
    this.handleChart1()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  watch:{
    wordCloudType(newVal,oldVal){
      console.log(newVal,oldVal)
      this.handleChart2()
    },
    wordCloudType2(newVal,oldVal){
      console.log(newVal,oldVal)
      this.handleHotCompany()
    }
  }
}
</script>

<style scoped>

.data-cards {
  margin-bottom: 20px;
}



.chart {
  height: 300px;
}
.item{
  text-align: center;
}
</style>